import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { TrendingUp, ArrowLeft } from 'lucide-react';

const RedevancePage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen pb-12">
      <Header />
      
      <main className="pt-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button 
          onClick={() => navigate('/dashboard')}
          variant="ghost"
          className="mb-6"
        >
          <ArrowLeft className="mr-2" size={18} />
          Retour au Dashboard
        </Button>
        
        <Card className="glass border-zinc-800">
          <CardHeader>
            <CardTitle className="flex items-center gap-3 text-3xl">
              <TrendingUp className="text-[#E50914]" size={32} />
              💰 Mes Redevances
            </CardTitle>
          </CardHeader>
          <CardContent className="py-12">
            <div className="text-center">
              <p className="text-zinc-400 text-lg mb-4">
                Cette fonctionnalité arrive bientôt ! 🚀
              </p>
              <p className="text-zinc-500 text-sm">
                Vous pourrez suivre vos gains et redevances ici.
              </p>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default RedevancePage;
